module.exports = __webpack_public_path__ + "static/img/mate.46af03d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/mate.png
// module id = FW6W
// module chunks = 0